import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAppConfig } from '../services/configService';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

const ConfigContext = createContext({
    statuses: [],
    loadingConfig: true,
    configError: null,
});

export const ConfigProvider = ({ children }) => {
    const [statuses, setStatuses] = useState([]);
    const [loadingConfig, setLoadingConfig] = useState(true);
    const [configError, setConfigError] = useState(null);
    const [userChecked, setUserChecked] = useState(false); // Track if auth state check is done

    useEffect(() => {
        // Subscribe to auth state changes
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setUserChecked(true); // Mark auth check as done
            if (user) {
                // User is logged in, fetch config
                setLoadingConfig(true);
                setConfigError(null);
                try {
                    console.log("User authenticated, fetching app config...");
                    const configData = await getAppConfig();
                    console.log("App config fetched:", configData);
                    setStatuses(configData.statuses || []);
                } catch (err) {
                    console.error("Failed to fetch app config:", err);
                    setConfigError(err.message || 'Could not load application configuration.');
                    setStatuses([]); // Clear statuses on error
                } finally {
                    setLoadingConfig(false);
                }
            } else {
                // User is logged out, reset state
                console.log("User logged out, clearing config.");
                setStatuses([]);
                setLoadingConfig(false); // No longer loading if user is logged out
                setConfigError(null);
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []); // Empty dependency array ensures this runs once on mount

    // Render children only after the initial auth state check is complete
    // and config is either loaded or failed (or user is logged out)
    if (!userChecked) {
         // Optionally show a global loading indicator while checking auth
         return <div>Checking authentication...</div>;
    }


    return (
        <ConfigContext.Provider value={{ statuses, loadingConfig, configError }}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);
